import { Pagination } from '@/constants/pagination';
import { CustomerKycDetailType, CustomerType, KycStatusType } from '@/types/customer';
import { PaginationAPI } from '@/types/pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';


export type CustomerState = {
  data: CustomerType[];
  pagination: PaginationAPI;
  totalElements?: number;
  loading: boolean;
  dataKycCustomerDetail?: CustomerKycDetailType;
  kycStatus?: KycStatusType[];
  filters: CustomerFilterState;
};

export type CustomerFilterState = {
  status?: string;
  dateRange?: string;
  fromDate?: string;
  toDate?: string;
  search?: string;
};

export const customerInitialState: CustomerState = {
  data: [],
  pagination: {
    Page: Pagination.Page,
    totalPages: 0,
    totalElements: 0,
    Size: Pagination.Size,
  },
  loading: false,
  kycStatus: [],
  filters: {},
};

const slice = createSlice({
  name: 'customers',
  initialState: customerInitialState,
  reducers: {
    setListCustomerAction(
      state,
      action: PayloadAction<{
        data: CustomerType[];
        pagination?: PaginationAPI;
        totalExtend?: number;
        append?: boolean;
      }>
    ) {
      const { payload } = action;
      
      if (payload.append) {
        // Append new data to existing data
        state.data = [...state.data, ...payload.data];
      } else {
        // Replace existing data
        state.data = payload.data;
      }
      
      state.pagination = payload.pagination || state.pagination;
      state.totalElements = payload.pagination?.totalElements;
    },

    setDetailsKycCustomerAction(
      state,
      { payload }: PayloadAction<CustomerKycDetailType>
    ) {
      state.dataKycCustomerDetail = payload;
    },

    setKYCStatusAction(
      state,
      { payload }: PayloadAction<{ kycStatus: KycStatusType[] }>
    ) {
      state.kycStatus = payload.kycStatus;
    },
    setCustomerFiltersAction(
      state,
      action: PayloadAction<CustomerFilterState>
    ) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetCustomerFiltersAction(state) {
      state.filters = {};
    }
  },
});

export const {
  setListCustomerAction,
  setDetailsKycCustomerAction,
  setKYCStatusAction,
  setCustomerFiltersAction,
  resetCustomerFiltersAction
} = slice.actions;

export default slice.reducer;
